import { maskedGridColumnType } from "../libs/data/maskedGridColumnType";
import PropTypes from 'prop-types';

export const renderMaskedColumn = (rowData, col) => {
    const value = rowData[col.fieldName];
    if (!value) return "";

    // Clean the value (for number-based fields like phone, fax, SSN)
    const cleaned = ('' + value).replace(/\D/g, '');

    // Extract maskFormat and allowShort from column settings
    const { maskFormat, allowShort = false } = col?.colSettings || {};

    // Handle dynamically based on the maskFormat provided
    switch (col.colSettings.maskType) {
        case maskedGridColumnType.PHONENUMBR:
        case maskedGridColumnType.FAXNUMBER:
            return handlePhoneFaxMask(cleaned, maskFormat, allowShort);

        case maskedGridColumnType.PERCENTAGE:
            return formatPercentage(value); // Apply percentage format logic

        case maskedGridColumnType.MONEY:
            return formatMoney(value); // Apply currency format logic

        case maskedGridColumnType.CREDITCARD:
        case maskedGridColumnType.ZIPCODE:
        case maskedGridColumnType.SSN:
            return formatWithMask(cleaned, maskFormat); // Apply mask directly from config

        default:
            return value; // Return original value for unhandled types
    }
};

// Handle phone/fax number masking
const handlePhoneFaxMask = (cleaned, maskFormat, allowShort) => {
    if (cleaned.length > 10) {
        const countryCode = cleaned.slice(0, cleaned.length - 10);
        const mainNumber = cleaned.slice(-10);
        const formattedMainNumber = formatWithMask(mainNumber, maskFormat);
        return `+${countryCode} ${formattedMainNumber}`;
    } else if (cleaned.length === 10 || (allowShort && cleaned.length > 6)) {
        return formatWithMask(cleaned, maskFormat); // Apply mask for valid lengths
    } else {
        return "Invalid Number"; // Handle invalid numbers
    }
};

// Helper to format numbers or strings using a mask
const formatWithMask = (value, maskFormat) => {
    let i = 0;
    return maskFormat.replace(/#/g, () => value[i++] || '');
};

// Format percentage
const formatPercentage = (value) => `${parseFloat(value).toFixed(2)}%`;

// Format money
const formatMoney = (value) => {
    const number = parseFloat(value).toFixed(2);
    return `$${number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

renderMaskedColumn.propTypes = {
    rowData: PropTypes.object.isRequired,
    col: PropTypes.shape({
        fieldName: PropTypes.string.isRequired,
        colSettings: PropTypes.shape({
            maskType: PropTypes.oneOf(Object.values(maskedGridColumnType)).isRequired,
            maskFormat: PropTypes.string,
            allowShort: PropTypes.bool,
        })
    }).isRequired,
};